<template>
  <div v-if="obs" class="col-12 px-0">
    <span class="font-weight-bold">Observação: </span>
    <span>{{ showFullObs ? obs : shortObs }}</span>
    <b-button size="sm" variant="outline-info" @click.stop="toggleShowFullObs()" class="ml-1 py-0 px-2">
      {{ showFullObs ? '\<' : '...' }}
    </b-button>
  </div>
</template>

<script>
import Vue from "vue";
import shared from "@/shared/shared";

const CHAR_LIMIT = 120;
const SHOW_FULL_OBS_LOCAL_STORAGE_KEY = 'order-item-observation:showFullObs'
const stateByKey = {};

function getState(key) {
  if (!stateByKey[key]) {
    stateByKey[key] = Vue.observable({
      showFullObs: false
    });
  }
  return stateByKey[key];
}

const obsState = Vue.observable({
  showFullObs: false
});

export default {
  name: 'order-item-observation',

  props: {
    orderItem: {
      type: Object
    }
  },

  data() {
    return {
    }
  },

  mounted() {
    let cachedShowFullObs = shared.getLocalStorageObj(this.localStorageShowFullObsKey);

    if (cachedShowFullObs == true) {
      let state = getState(this.groupKey);
      state.showFullObs = true;
    }
  },

  computed: {
    // id() {
    //   if (this.orderItem) {
    //     return this.groupKey + "_" + this.$options.name + "_" + this.orderItem.id;
    //   }
    // },

    groupKey() {
      return this.$parent.$options.name || "default";
    },

    localStorageShowFullObsKey() {
      return SHOW_FULL_OBS_LOCAL_STORAGE_KEY + "_" + this.groupKey;
    },

    showFullObs() {
      return getState(this.groupKey).showFullObs;
    },

    obs() {
      return this.orderItem ? this.orderItem.iteObservations : undefined;
    },

    shortObs() {
      if (this.obs) {
        let obs = this.obs
          .trim()                 // remove espaços/quebras no início e fim
          .split(/\r?\n/)[0];     // pega apenas a primeira linha

        if (obs.length > CHAR_LIMIT) {
          obs = obs.slice(0, CHAR_LIMIT);
        }

        return obs;
      }
    }
  },

  methods: {
    toggleShowFullObs() {
      let state = getState(this.groupKey);
      state.showFullObs = !state.showFullObs;
      shared.setLocalStorageObj(this.localStorageShowFullObsKey, state.showFullObs);

      // if (this.id) { //Não funcionou
      //   setTimeout(() => {
      //     let el = document.getElementById(this.id);

      //     if (el) {
      //       el.scrollIntoView({
      //         behavior: "smooth"
      //       });
      //     }
      //   }, 500);
        //this.$nextTick(() => {

        //});
      // }
    }
  }
}
</script>
